module.exports = __webpack_public_path__ + "img/article.a4420dd3.png";